import React from "react";
import { useParams } from "react-router-dom";
import blogs from "./Blog/blogs";
import Aside from "./aside";
import NavigationSub from "./NavigationSub";
import FooterSub from "./FooterSub";
import FloatingSocials from "./FloatingSocials";

const BlogPage = () => {
  const { slug } = useParams();

  const blog = blogs.find((item) => item.slug === slug);

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <h1 className="text-3xl font-semibold">Blog Not Found</h1>
      </div>
    );
  }

  return (
    <>
      <NavigationSub />

      <section className="pt-24 pb-12 sm:pb-16 md:pb-24 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-10 md:mb-12">
            <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-foreground mb-4 sm:mb-6 py-4">
              Our Blog
            </h2>
          </div>
          <div className="flex flex-360">
            <Aside />
            <main className="flex-1 p-6 pt-0 bg-white-100">
              <div className="flex flex-col gap-3">
                <h1 className="font-heading text-2xl sm:text-2xl md:text-3xl font-bold">
                  {blog.title}
                </h1>
                <p className="text-xs italic">{blog.date}</p>
                <img
                    src={blog.image}
                    alt={blog.title}
                    className="w-full h-56 object-cover"
                  />
                <div className="bg-white p-4 rounded shadow whitespace-pre-line">
                  {blog.description}
                </div>
              </div>
            </main>
          </div>
         
        </div>
      </section>
      <FloatingSocials />
      <FooterSub />
    </>
  );
};

export default BlogPage;
